/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPcDesktopIcon16Light } from './TechPcDesktopIcon16Light';
import { TechPcDesktopIcon16Regular } from './TechPcDesktopIcon16Regular';
import { TechPcDesktopIcon16Solid } from './TechPcDesktopIcon16Solid';
import { TechPcDesktopIcon20Light } from './TechPcDesktopIcon20Light';
import { TechPcDesktopIcon20Regular } from './TechPcDesktopIcon20Regular';
import { TechPcDesktopIcon20Solid } from './TechPcDesktopIcon20Solid';
import { TechPcDesktopIcon24Regular } from './TechPcDesktopIcon24Regular';
import { TechPcDesktopIcon24Solid } from './TechPcDesktopIcon24Solid';
import { TechPcDesktopIcon32Regular } from './TechPcDesktopIcon32Regular';
import { TechPcDesktopIcon64Regular } from './TechPcDesktopIcon64Regular';
var sizes = {
    16: {
        light: TechPcDesktopIcon16Light,
        regular: TechPcDesktopIcon16Regular,
        solid: TechPcDesktopIcon16Solid,
    },
    20: {
        light: TechPcDesktopIcon20Light,
        regular: TechPcDesktopIcon20Regular,
        solid: TechPcDesktopIcon20Solid,
    },
    24: {
        regular: TechPcDesktopIcon24Regular,
        solid: TechPcDesktopIcon24Solid,
    },
    32: {
        regular: TechPcDesktopIcon32Regular,
    },
    64: {
        regular: TechPcDesktopIcon64Regular,
    },
};
export var TechPcDesktopIcon = forwardRef('TechPcDesktopIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
